module.exports = __webpack_public_path__ + "28bd6b051bc6f215b4e69a17ab73f077.gif";


//////////////////
// WEBPACK FOOTER
// ./public/img/counter-icons/12_icon_coffee.gif
// module id = 685
// module chunks = 0